import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b210e13e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b210e13e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b210e13e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b210e13e')) {
      api.createRecord('b210e13e', component.options)
    } else {
      api.reload('b210e13e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b210e13e&scoped=true", function () {
      api.rerender('b210e13e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobile/orderCancellation/index.vue"
export default component.exports